// cleanup_convert_to_typescript_file_SMB_EMPLOYEE_PAYMENT
// cleanup_remove_external_libraries_SMB_EMPLOYEE_PAYMENT

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { template } from 'lodash';
import moment from 'moment';

import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';

import { DATE_FORMAT, PAYMENT_ACTIONS } from 'constants.js';
import AppPropTypes from 'proptypes/AppPropTypes';
import { numberToCurrency } from 'utils/currency';

import { getNumberOfTransactions } from './shared';

const ConfirmModal = ({
  action,
  actionCallback,
  actionTitle,
  classes: { bold, continueButton },
  formState,
  locale,
  onHide,
  totalAmount
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const alertMsg = [PAYMENT_ACTIONS.APPROVE, PAYMENT_ACTIONS.SEND].includes(action) ? (
    <>
      {template(locale['employee.payment.alert.approve'])({
        action
      })}
      &nbsp;
      <span className={bold}>{locale['employee.payment.employeePayment']}</span>&nbsp;
      {locale['common.to']}&nbsp;
      <span className={bold}>
        {getNumberOfTransactions(formState.transactions)} {locale['employees.payment.employees']}
      </span>
      .
    </>
  ) : (
    <>
      {template(locale['employee.payment.alert'])({
        action
      })}
      &nbsp;
      <span className={bold}>{locale['employee.payment.employeePayment']}</span>&nbsp;
      {locale['employees.payment.for']}&nbsp;
      <span className={bold}>{numberToCurrency(totalAmount)}</span>&nbsp;
      {locale['employees.payment.fromAccount']}&nbsp;
      <span className={bold}>{formState?.batch?.fromAccount?.[0]?.name}</span>&nbsp;
      {locale['common.onLabel']}&nbsp;
      {moment(formState?.batch?.effectiveEntryDate?.[0]).format(DATE_FORMAT)}.
    </>
  );

  const handleAction = () => {
    setIsSubmitting(true);
    if (!isSubmitting) {
      actionCallback();
    }
  };

  return (
    <>
      <div>
        <h2 className="modal-header">{actionTitle}</h2>
        <div className="modal-text">
          <p>{alertMsg}</p>
          <br />
          <p className={bold}>{locale['paymentAction.modalBody.proceed']}</p>
        </div>
      </div>
      <Button
        className={continueButton}
        onClick={handleAction}
        data-qa="route-guard-continue"
        text={locale['common.continue']}
        variant={PRIMARY}
        disabled={isSubmitting}
      />

      <Button
        onClick={onHide}
        data-qa="route-guard-cancel"
        text={locale['common.cancel']}
        variant={TERTIARY}
      />
    </>
  );
};

ConfirmModal.propTypes = {
  action: PropTypes.string.isRequired,
  actionTitle: PropTypes.string.isRequired,
  actionCallback: PropTypes.func.isRequired,
  formState: PropTypes.shape({}).isRequired,
  locale: AppPropTypes.locale.isRequired,
  history: PropTypes.shape({}).isRequired,
  onHide: PropTypes.func.isRequired,
  totalAmount: PropTypes.string
};

ConfirmModal.defaultProps = {
  totalAmount: ''
};

export default ConfirmModal;
